// Site relies on global jquery, so do not remove this
import $ from 'jquery';

global.jQuery = $;
global.$ = $;
